<template>
<div class="chapter">
<div class="inner_page">
<div class="body"><a id="page6"></a><a id="page7"></a>
<p class="acknowledgments-title"><strong>ACKNOWLEDGEMENTS</strong></p>
<p class="noindent">“Japanese Baseball” appeared in <em>Dandelion</em>, and <em>Iowa City Magazine</em>, and “Wavelengths” “The Arbiter” and “The Mansions of Federico Juarez” in <em>Iowa City Magazine</em>. “The First and Last Annual Six Towns Area Old-Timers’ Game” was published as a collectors’ edition chapbook by Coffee House Press of Minneapolis. “The Lime Tree” was published by <em>Elysian Fields Magazine</em>, and “Tulips” accepted by <em>Dugout Magazine</em>. “The Kowloon Cafe” was accepted by Heartlands. “The Indestructable Hadrian Wilks” was anthologized in <em>Baseball Fantastic</em> published by Quarry Press, and published by Passages North. “Fred Noonan Flying Services” was anthologized in <em>Baseball Fantastic</em>, and published by Westview.</p>
<a id="page8"></a><a id="page9"></a><a id="page10"></a>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0003.vue?76622e03